import { get } from 'svelte/store';
import client, { PRIVATE_CLIENT } from '../../services/client';
import sessionStore from '../../store/session';
import authStore from '../../store/auth';
import { AmplitudeLogger, EVENTS } from '../../services/utils';
import { createContacts } from '../call/contact.action';
const BASE_URL = 'https://telephony.api.pressone.co/api/v1/';
export const getOauthStatus = async () => {
    const { has_crm_linked = false } = await client.get(`${BASE_URL}zoho/crm/has_crm_linked/`, PRIVATE_CLIENT, null, {});
    return has_crm_linked;
};
export const setActiveNumber = async (number) => {
    return await client.post(`${BASE_URL}zoho/crm/active-number/`, PRIVATE_CLIENT, {
        number
    });
};
export const createCall = async (call_id) => {
    const { profile } = get(sessionStore);
    const { user } = get(authStore);
    return await client.post(`${BASE_URL}zoho/crm/create-call/`, PRIVATE_CLIENT, {
        call_id,
        user: (user === null || user === void 0 ? void 0 : user.id) || (profile === null || profile === void 0 ? void 0 : profile.user),
    });
};
export const setCallRecordID = async (call_id, record_id, note) => {
    return await client.post(`${BASE_URL}zoho/crm/set-call-record/`, PRIVATE_CLIENT, {
        call_id, record_id, note
    });
};
export const generateOauthUrl = async () => {
    const { profile } = get(sessionStore);
    const { user } = get(authStore);
    let info = await ZOHO.CRM.CONFIG.getOrgInfo();
    const { zgid: org_id } = info.org[0];
    const zoho_user = await ZOHO.CRM.CONFIG.getCurrentUser();
    const zoho_id = zoho_user.users[0].id;
    const scope = 'ZohoCRM.modules.ALL';
    const cliend_id = '1000.U6BSA77R7N04FXY2G176M59JDX2UTM';
    const response_type = 'code';
    const access_type = 'offline';
    const state = JSON.stringify({
        app: 'CRM',
        user: (user === null || user === void 0 ? void 0 : user.id) || (profile === null || profile === void 0 ? void 0 : profile.user),
        org_id,
        zoho_id,
    });
    const encoded_state = encodeURIComponent(state);
    const oauth_uri = 'https://telephony.api.pressone.co/api/v1/zoho/oauth/';
    return `https://accounts.zoho.com/oauth/v2/auth?scope=${scope}&client_id=${cliend_id}&response_type=${response_type}&access_type=${access_type}&redirect_uri=${oauth_uri}&state=${encoded_state}`;
};
export const syncContact = async (business_id, page = 1) => {
    ZOHO.CRM.API.getRecord({
        Entity: "Leads", approved: "both", //RecordID:"1000000030132"
    })
        .then(async function (response) {
        const { data = [], info: { page = 1, per_page = 200, more_records } } = response;
        const contacts = data.map(record => ({
            name: record.Full_Name,
            number: record.Mobile || record.Phone,
            email: record.Email,
            company: record.Company,
            address: `${record.Street} ${record.State} ${record.City} ${record.Country} ${record.Zip_Code}`
        }));
        await createContacts(business_id, contacts);
        if (more_records) {
            await syncContact(business_id);
        }
    })
        .catch(_ => { })
        .finally(() => {
        AmplitudeLogger.log(EVENTS.SYNC_CONTACT);
    });
};
